import React from 'react';
import PropTypes from 'prop-types';
import  { useSelector } from 'react-redux'
import  { useDispatch } from 'react-redux'
import { updateRilevanzaAmbiti } from '../reduxStore/questCorrenteSlice'
import { useForm, Controller } from 'react-hook-form';
import { Form } from 'react-bootstrap';

import { BsPencil } from "react-icons/bs";
import { BsInfoCircleFill } from "react-icons/bs";
import { Row, Col, Card, Modal, Button } from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';
import FalconCloseButton from 'components/common/FalconCloseButton';
import Flex from 'components/common/Flex';
import { TextWithLineBreaks } from '../components-csvc/TextWithLineBreaks'

function colore(valore) {
  return (valore===10) ? 'info'
  : (valore===30) ? 'primary'
  : (valore===50) ? 'secondary'
  : (valore===70) ? 'warning'
  : (valore===90) ? 'danger'
  : 'warning' 
}

function label(valore) {
  return (valore===10) ? 'bassa'
  : (valore===30) ? 'moderata'
  : (valore===50) ? 'media'
  : (valore===70) ? 'alta'
  : (valore===90) ? 'molto alta'
  : 'RILEVANZA NON DEFINITA' 
}

export const CompilaQuestionarioRilevanza = (props) => {

  // ----------------------------------------------------------
  // estraggo dal parametro ricevuto in input l'ambito e l'effetto
  const rilevanzaAmbito = props.impatto.substring(0, 7);
  const rilevanzaEffetto = (props.impatto.substring(8, 10) === 'R1') ? 'io'
    : (props.impatto.substring(8, 10) === 'R2') ? 'oi'
    : 'XX';

  const questionarioCorrente = useSelector((state) => state.questCorrente);
  const rilevanzaAmbitiArray = questionarioCorrente.rilevanzaAmbiti;

  const rilevanzaAmbitiFiltered = rilevanzaAmbitiArray.filter((el) => {
    return el.ambito === rilevanzaAmbito;
  });
  console.log ('rilevanzaEffetto: ', rilevanzaEffetto)
  console.log ('rilevanzaAmbitiFiltered: ', rilevanzaAmbitiFiltered)
  
  const rilevanzaQuestoAmbitoObject = rilevanzaAmbitiFiltered[0];
  const rilevanzaValore = (rilevanzaEffetto === 'io') ? rilevanzaQuestoAmbitoObject.io
    : (rilevanzaEffetto === 'oi') ? rilevanzaQuestoAmbitoObject.oi
    : 0;
  const rilevanzaEri = (rilevanzaEffetto === 'io') ? rilevanzaQuestoAmbitoObject.ioEri
    : (rilevanzaEffetto === 'oi') ? rilevanzaQuestoAmbitoObject.oiEri
    : 0;
      
  console.log ('rilevanzaValore: ', rilevanzaValore)

  // ----------------------------------------------------------
  //  INIZIO GESTIONE PER react-hook-form
  const { control, handleSubmit, formState: { errors } } = useForm();
	const dispatch = useDispatch();

  const onReactHookFormSubmit = (data) => {
    console.log('**##** onReactHookFormSubmit - data: ', data);

        const updatedValues = {
          questionarioUuid: questionarioCorrente.questionarioUuid, 
          ambito: data.rilevanzaAmbito, 
          effetto: data.rilevanzaEffetto, 
          valore: data.rilevanzaRadioValore.toString(),
          eri: data.eriValore
        }

        console.log('**## onReactHookFormSubmit - updatedValues: ', updatedValues)
        dispatch(updateRilevanzaAmbiti(updatedValues)) 

    setModalShow(false);
  };
	
  //  FINE GESTIONE PER react-hook-form
  // ----------------------------------------------------------


//  const dispatch = useDispatch();
  
  // ----------------------------------------------------------
  //  INIZIO GESTIONE Modal

  const [rilevanzaRadioValore, setRilevanzaRadioValore] = React.useState(rilevanzaValore);
  const [modalShow, setModalShow] = React.useState(false);

  const handleCloseModal = () => setModalShow(false);

  const handleOpenModalToUpdateValues = () => {
    setRilevanzaRadioValore(Number(rilevanzaValore))
    setModalShow(true)
  };

  const handleChange = (event) => {
    setRilevanzaRadioValore(Number(event.target.value));
  };

  //  FINE GESTIONE Modal
  // ----------------------------------------------------------


  return (<>
    <Card className="bg-100 shadow-none border mb-3">
      <Card.Body className="py-0">
        <Row className="g-0 justify-content-between" style={{ margin: "1%" }}>
          <Col sm="9">
            <Flex alignItems="center">
              <div>
              <h4 className="text-primary fw-bold mb-0"><span className="text-info fw-medium">Rilevanza</span> {
                (rilevanzaEffetto==='io') ? 'INSIDE-OUT'
                : (rilevanzaEffetto==='oi') ? 'OUTSIDE-IN'
                : 'codice Effetto NON valido' 
            } <span className="text-info fw-medium">per</span> {rilevanzaAmbito} <span className="text-info fw-medium"></span></h4>
              </div>
            </Flex>
          </Col>
          <Col md="auto" className="mb-3 mb-md-0">
            <Row className="g-3 gy-md-0 h-100 align-items-center">
              <Col xs="auto" style={{ margin: "10%" }}>
                <Button variant={(rilevanzaValore === 0) ? 'danger' : 'success'} onClick={handleOpenModalToUpdateValues}>
                  <BsPencil />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>

        <Card style={{ marginBottom: "1%", marginTop: "1%" }}>
          <Card.Title as='h6' style={{ marginTop: "1%", marginLeft: "1%" }}>
            <h6 className="text-primary mb-0"><BsInfoCircleFill className="fa fa-question-circle fa-lg" /><em>&nbsp;&nbsp;&nbsp;Un suggerimento per ERI (Entità rischio iniziale):</em></h6>
          </Card.Title>
            <Card.Body>
                <span className="fw-small">
                {props.eriRowsObjectArray.map((rigaEri) => (<><p className="text-primary  mb-0">{rigaEri.text}</p></>))}
                </span>
            </Card.Body>
        </Card>

        <Card style={{marginBottom:"1%" , marginTop:"1%"}}>
            <Card.Title as='h6' style={{marginTop:"1%", marginLeft:"1%"}}>
                <h5 className="text-primary  mb-0">ERI - Entità Rischio Iniziale</h5>
            </Card.Title>
            <Card.Body>
                <span className="fw-small">
                {<TextWithLineBreaks text={rilevanzaEri} />}
                </span>
            </Card.Body>
        </Card>

        <Row className="g-0 justify-content-between">
          <div>
            <ProgressBar variant={colore(rilevanzaValore)} min="0" max="90" now={rilevanzaValore} className='mb-3' label={label(rilevanzaValore)} />
          </div>
        </Row>
      </Card.Body>
    </Card>

    <Modal size="lg" show={modalShow} onHide={handleCloseModal} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>Indica la rilevanza {
          (rilevanzaEffetto === 'io') ? 'INSIDE-OUT'
            : (rilevanzaEffetto === 'oi') ? 'OUTSIDE-IN'
              : 'codice Effetto NON valido'
        } per {rilevanzaAmbito}</Modal.Title>
        <FalconCloseButton onClick={handleCloseModal} />
      </Modal.Header>
      <Card style={{ marginBottom: "1%", marginTop: "1%" }}>
        <Card.Title as='h6' style={{ marginTop: "1%", marginLeft: "1%" }}>
          <h6 className="text-primary mb-0"><BsInfoCircleFill className="fa fa-question-circle fa-lg" /><em>&nbsp;&nbsp;&nbsp;Un suggerimento per ERI (Entità rischio iniziale):</em></h6>
        </Card.Title>
          <Card.Body>
            <span className="fw-small">
            {props.eriRowsObjectArray.map((rigaEri) => (<><p className="text-primary  mb-0">{rigaEri.text}</p></>))}
            </span>
          </Card.Body>
      </Card>

      <Form onSubmit={handleSubmit(onReactHookFormSubmit)}>
        <Controller
          name="rilevanzaAmbito"
          control={control}
          defaultValue={rilevanzaAmbito}
          render={({ field }) => (
            <input type="hidden" {...field} />
          )}
        />
        <Controller
          name="rilevanzaEffetto"
          control={control}
          defaultValue={rilevanzaEffetto}
          render={({ field }) => (
            <input type="hidden" {...field} />
          )}
        />
        <Modal.Body>
          <Form.Group controlId="eriValore">
            <Controller
              name="eriValore"
              control={control}
              defaultValue={rilevanzaEri}
              render={({ field }) => (
                <textarea
                  {...field}
                  autoComplete="off"
                  style={{ height: '150px', width: '100%' }}
                ></textarea>
              )}
            /><br />
            {errors.eriValore && <span style={{color: 'red'}} ><p>La giustificazione è obbligatoria</p></span>}
          </Form.Group>

          <Form.Group controlId="rilevanzaRadioValore">
            <Form.Label>Rilevanza Valore </Form.Label>
            <div>
              <label style={{ margin: "2%" }}>
                <Controller
                  name="rilevanzaRadioValore"
                  control={control}
                  defaultValue={rilevanzaRadioValore}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="radio"
                      value="10"
                      checked={Number(field.value) === 10}
                      onChange={(e) => {
                        field.onChange(e);
                        handleChange(e);
                      }}
                    />
                  )}
                />
                &nbsp;&nbsp;Bassa
              </label>
              <label style={{ margin: "2%" }}>
                <Controller
                  name="rilevanzaRadioValore"
                  control={control}
                  defaultValue={rilevanzaRadioValore}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="radio"
                      value="30"
                      checked={Number(field.value) === 30}
                      onChange={(e) => {
                        field.onChange(e);
                        handleChange(e);
                      }}
                    />
                  )}
                />
                &nbsp;&nbsp;Moderata
              </label>
              <label style={{ margin: "2%" }}>
                <Controller
                  name="rilevanzaRadioValore"
                  control={control}
                  defaultValue={rilevanzaRadioValore}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="radio"
                      value="50"
                      checked={Number(field.value) === 50}
                      onChange={(e) => {
                        field.onChange(e);
                        handleChange(e);
                      }}
                    />
                  )}
                />
                &nbsp;&nbsp;Media
              </label>
              <label style={{ margin: "2%" }}>
                <Controller
                  name="rilevanzaRadioValore"
                  control={control}
                  defaultValue={rilevanzaRadioValore}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="radio"
                      value="70"
                      checked={Number(field.value) === 70}
                      onChange={(e) => {
                        field.onChange(e);
                        handleChange(e);
                      }}
                    />
                  )}
                />
                &nbsp;&nbsp;Alta
              </label>
              <label style={{ margin: "2%" }}>
                <Controller
                  name="rilevanzaRadioValore"
                  control={control}
                  defaultValue={rilevanzaRadioValore}
                  render={({ field }) => (
                    <input
                      {...field}
                      type="radio"
                      value="90"
                      checked={Number(field.value) === 90}
                      onChange={(e) => {
                        field.onChange(e);
                        handleChange(e);
                      }}
                    />
                  )}
                />
                &nbsp;&nbsp;Molto Alta
              </label>
            </div>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Annulla
          </Button>
          <Button variant="primary" type="submit">Invia</Button>
        </Modal.Footer>
      </Form>


    </Modal>

  </>);
};

CompilaQuestionarioRilevanza.propTypes = {
  impatto: PropTypes.string.isRequired,
  eriRowsObjectArray: PropTypes.array
};
